import { Component } from '@angular/core';
import { ExtendedInputType, InputStatus } from '@infocert/ng-ui-kit/models';
import { FieldType, FieldTypeConfig, FormlyConfig } from '@ngx-formly/core';
import { isObject } from 'lodash-es';
import { Observable, of } from 'rxjs';
@Component({
    selector: 'formly-field-ic1-input',
    template: `
    <div [ngClass]="classes">
      <ng-ui-kit-input
        [type]="type"
        [id]="id"
        [icId]="id"
        [icName]="name"
        [label]="props.label"
        [OnlyNumbers]="OnlyNumbers"
        [placeholder]="props.placeholder"
        [status]="status"
        [formControl]="formControl"
        [errorLabel]="(errorLabel | async) || ''"
        [formlyAttributes]="field"
        [minlength]="props.minlength"
        [maxlength]="props.maxlength"></ng-ui-kit-input>

      <div
        *ngIf="description"
        [translate]="description"
        class="formly-description"></div>

      <div *ngIf="showError" class="formly-error">
        {{ errorLabel | async }}

        <span *ngIf="currentError === 'PASSWORD_STRENGHT'">
          <ng-ui-kit-tooltip [icId]="'ic1-tooltip-long'" [color]="'warning'">
            <h4 translate>COMMON.VALIDATORS.PASSWORD_SECURITY</h4>
            <div translate>COMMON.VALIDATORS.PASSWORD_DESCRIPTION</div>
          </ng-ui-kit-tooltip>
        </span>

        <span *ngIf="currentError === 'PASSWORD_STRENGHT_MINOSSE'">
          <ng-ui-kit-tooltip [icId]="'ic1-tooltip-long'" [color]="'warning'">
            <h4 translate>COMMON.VALIDATORS.PASSWORD_SECURITY</h4>
            <div translate>COMMON.VALIDATORS.PASSWORD_DESCRIPTION_MINOSSE</div>
          </ng-ui-kit-tooltip>
        </span>
      </div>
      <!-- <pre
        >{{ field | json }}
  </pre> -->
    </div>
  `,
    standalone: false
})
export class InputFieldType extends FieldType<FieldTypeConfig> {
  constructor(private config: FormlyConfig) {
    super();
  }

  currentError: string;

  //se l'id è  stato settato in automatico da formly non lo prendo ma uso quello di key
  override get id(): string {
    if (!this.field.id.includes('formly_')) {
      return `${this.field.id || this.field.key}`;
    } else {
      return `${this.field.key}`;
    }
  }

  get name(): string {
    return `${this.field.name || this.id}`;
  }

  get OnlyNumbers(): any {
    return this?.props?.['OnlyNumbers'] || false;
  }
  get classes() {
    return `formly-input ${this.type} `;
  }

  get type(): ExtendedInputType {
    return (this.props.type || 'text') as ExtendedInputType;
  }

  get status(): InputStatus {
    return this.showError ? 'error' : 'informative';
  }

  get showStrenght(): boolean {
    return this.currentError === 'PASSWORD_STRENGHT';
  }
  get description() {
    return this.props?.description || '';
  }

  get errorLabel(): Observable<string> {
    const fieldForm = this.field.formControl;
    this.currentError = '';

    const errors = fieldForm?.errors;
    if (!errors) return of(undefined);

    // Priorità: se c'è mismatch (SAME_*), vogliamo mostrare quello e non minlength/maxlength.
    const preferredOrder = [
      'SAME_PASSWORD',
      'SAME_PIN',
      'SAME_PIN_PUK',
      'SAME_OLD_PASSWORD',
      'required',
      'minlength',
      'maxlength',
      'PASSWORD_STRENGHT',
      'PASSWORD_STRENGHT_MINOSSE',
    ];

    const buildMessage = (error: string): Observable<string> => {
      let message = this.config.getValidatorMessage(error);
      this.currentError = error;

      const errorValue = errors[error];
      if (isObject(errorValue)) {
        if (errorValue.errorPath) {
          return of(undefined);
        }
        if ((errorValue as any).message) {
          message = (errorValue as any).message;
        }
      }

      if (this.field.validation?.messages?.[error]) {
        message = this.field.validation.messages[error];
      }

      if (this.field.validators?.[error]?.message) {
        message = this.field.validators[error].message;
      }

      if (this.field.asyncValidators?.[error]?.message) {
        message = this.field.asyncValidators[error].message;
      }

      if (typeof message === 'function') {
        return (message as any)(
          errorValue,
          this.field
        ) as Observable<string>;
      }

      return of(message);
    };

    for (const errorKey of preferredOrder) {
      if (Object.prototype.hasOwnProperty.call(errors, errorKey)) {
        return buildMessage(errorKey);
      }
    }

    // fallback: usa l'ordine naturale delle chiavi
    for (const error in errors) {
      if (Object.prototype.hasOwnProperty.call(errors, error)) {
        return buildMessage(error);
      }
    }

    return of(undefined);
  }
}
